/** 👇 Stock */
const SearchStocks = () =>
  import(/* webpackChunkName: "searchStocks" */ '../views/SearchStocks.vue')
const StockDetails = () =>
  import(/* webpackChunkName: "stockDetails" */ '../views/StockDetails.vue')

const StockRoute = [
  {
    path: '/stock',
    name: 'stock',
    redirect: '/stock/in',
  },
  {
    path: '/stock/in',
    name: 'stock_in',
    component: SearchStocks,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: true,
      navBarBack: false,
      title: 'Cari Saham Indonesia',
      backLink: 'dashboard',
    },
  },
  {
    path: '/stock/us',
    name: 'stock_us',
    component: SearchStocks,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: true,
      navBarBack: false,
      title: 'Cari Saham US',
      backLink: 'dashboard',
    },
  },
  {
    path: '/stock/detail/:stock',
    name: 'stockdetail',
    component: StockDetails,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: true,
      navBarBack: false,
      title: 'Stock Details',
      backLink: 'stock',
    },
  },
]

export default StockRoute
